import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { fulfillmentContextService } from '~/services';
import type { ScheduleEntry } from '~/store/assets/types';
import { DOCK_LANE_SCHEDULE_QUERY_KEY } from './dockLaneQueryKeys';

export { DOCK_LANE_SCHEDULE_QUERY_KEY };

export const dockLaneScheduleQuery = {
  queryKey: DOCK_LANE_SCHEDULE_QUERY_KEY,
  configurationType: 'default' as const,
  fn: (laneId: string): Promise<ScheduleEntry[]> => fulfillmentContextService.fetchDockLaneSchedule(laneId),
};

export const useDockLaneSchedule = (laneId: string | undefined) => {
  return useQuery({
    ...useQueryCreator(dockLaneScheduleQuery, {
      args: [laneId!],
    }),
    enabled: !!laneId,
  });
};
